import React from 'react';
import Icon from '../../../components/AppIcon';

const CriticalAlerts = ({ alerts }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-gradient-to-br from-error/20 to-error/5 border-error text-error';
      case 'high':
        return 'bg-gradient-to-br from-warning/20 to-warning/5 border-warning text-warning';
      case 'medium':
        return 'bg-gradient-to-br from-accent/20 to-accent/5 border-accent text-accent';
      default:
        return 'bg-gradient-to-br from-muted to-muted/50 border-border text-muted-foreground';
    }
  };

  const getSeverityIconBg = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-gradient-to-br from-error to-error/60 shadow-lg shadow-error/30';
      case 'high':
        return 'bg-gradient-to-br from-warning to-warning/60 shadow-lg shadow-warning/30';
      case 'medium':
        return 'bg-gradient-to-br from-accent to-accent/60 shadow-lg shadow-accent/30';
      default:
        return 'bg-gradient-to-br from-muted to-muted/60';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertOctagon';
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'AlertCircle';
      default:
        return 'Info';
    }
  };

  const getSeverityLabel = (severity) => {
    switch (severity) {
      case 'critical':
        return 'Kritis';
      case 'high':
        return 'Tinggi';
      case 'medium':
        return 'Sedang';
      default:
        return 'Rendah';
    }
  };

  return (
    <div className="card bg-gradient-to-br from-card to-error/5 shadow-xl border-2">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent">Peringatan Risiko Kritis</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Temuan risiko tersembunyi yang memerlukan perhatian segera
          </p>
        </div>
        <div className="flex items-center gap-3 px-4 py-2 rounded-full bg-gradient-to-r from-error/20 to-error/10 border-2 border-error/30 shadow-lg">
          <div className="w-3 h-3 rounded-full bg-error animate-pulse shadow-lg shadow-error/50" />
          <span className="text-sm font-bold text-error">{alerts?.filter(a => a?.severity === 'critical')?.length} Kritis</span>
        </div>
      </div>
      <div className="space-y-4">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className={`p-5 md:p-6 rounded-2xl border-2 ${getSeverityColor(alert?.severity)} transition-all duration-300 hover:shadow-2xl transform hover:scale-[1.02]`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${getSeverityIconBg(alert?.severity)}`}>
                <Icon name={getSeverityIcon(alert?.severity)} size={22} className="text-white" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <h3 className="text-base md:text-lg font-bold">{alert?.title}</h3>
                  <span className={`px-4 py-1.5 rounded-full text-xs font-bold whitespace-nowrap ${getSeverityColor(alert?.severity)} shadow-md`}>
                    {getSeverityLabel(alert?.severity)}
                  </span>
                </div>

                <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                  {alert?.description}
                </p>

                <div className="flex flex-wrap items-center gap-4 text-sm mb-4">
                  <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-muted/50">
                    <Icon name="Target" size={16} className="text-muted-foreground" />
                    <span className="text-muted-foreground">Area:</span>
                    <span className="font-semibold">{alert?.area}</span>
                  </div>

                  <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/10">
                    <Icon name="Brain" size={16} className="text-primary" />
                    <span className="text-muted-foreground">Confidence:</span>
                    <span className="font-bold data-text text-primary">{alert?.confidence}%</span>
                  </div>

                  <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-muted/50">
                    <Icon name="Clock" size={16} className="text-muted-foreground" />
                    <span className="text-muted-foreground">{alert?.detectedAt}</span>
                  </div>
                </div>

                {alert?.recommendation && (
                  <div className="mt-4 p-4 rounded-xl bg-gradient-to-br from-primary/10 to-accent/10 border-2 border-primary/20 shadow-inner">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0 shadow-md">
                        <Icon name="Lightbulb" size={16} className="text-primary-foreground" />
                      </div>
                      <div>
                        <span className="text-sm font-bold text-primary">Rekomendasi:</span>
                        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{alert?.recommendation}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CriticalAlerts;